import type { Slider } from "@ui/slider";
import { useMemo, useState, type ComponentProps } from "react";
import { getExponentialRangeConfig } from "../services/getExponentialRangeConfig";

export function useExponentialRange({
  min = 1,
  max = 100,
  value = [],
}: Pick<ComponentProps<typeof Slider>, "min" | "max" | "value">) {
  const config = useMemo(() => getExponentialRangeConfig(min, max), [max, min]);
  const [localValue, setLocalValue] = useState(value);

  const internalValues = useMemo<number[]>(
    () => localValue.map(config.toInternal),
    [config, localValue],
  );

  function onChangeValue(values: number[]) {
    setLocalValue(values.map(config.toExternal));
  }

  return {
    config,
    internalValues,
    onChangeValue,
  };
}
